export default __webpack_public_path__ + "static/media/16.fbf1fd25.jpeg";